// extracted by mini-css-extract-plugin
export var container = "_83-0";
export var error = "_83-9";
export var label = "_83-5";
export var light = "_83-6";
export var md = "_83-3";
export var sm = "_83-2";
export var thin = "_83-8";
export var thinBold = "_83-7";
export var vertical = "_83-4";
export var xs = "_83-1";